<div  class="bg-white p-3 shadow-3 border-round-sm">


   <div class="rem-text-default flex align-items-center">
          <div class="rem-bg-light p-2 mr-2">
            <i class="pi pi-envelope font-medium"></i>
          </div>
          <div class="text-lg">Email Errors</div>
        </div>
        <div class="mt-6">

          <div class="px-3 flex align-items-center gap-3 mb-8">            
            <p-floatLabel>
              <p-calendar 
                    id="fromDate"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              />
              <label for="fromDate">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="toDate"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              />
              <label for="toDate">To Date</label>
            </p-floatLabel>

             <p-floatLabel>
              <input 
                  [(ngModel)]="failureDetailsStartsWith" 
                  class="w-full" 
                  pInputText   
                  id="failureDetailsStartsWith"                  
                  />
              <label for="failureDetailsStartsWith">Failure Details Starts With</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="recordCount"
                    class="w-full"
                    styleClass="w-full"
                    inputId="recordCount"                     
              /> 
              <label for="recordCount">Record Count</label>
            </p-floatLabel>

       
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraph()"
            >     
            </remitter-button>
          </div>

          <div *ngIf="chartOptionsPie" class="flex">
            <div class="flex-1 pl-3">
                  <div class="font-bold text-blue-600 text-lg">Summary of Email Errors <span *ngIf="failureDetailsStartsWith_Display">Where Failure Details Starts With '{{failureDetailsStartsWith_Display}}'</span></div>
                  <div class="font-bold text-700 text-sm mt-2">Top Creditors by Error Count</div>

                  <div *ngIf="isArrayWithData(tableData)">
                   <div echarts [options]="chartOptionsPie" class="donut-chart"></div>
                  </div>

                  <div *ngIf="!isArrayWithData(tableData)" class="flex align-items-center justify-content-center h-20rem">
                      <div class="font-bold text-red-700"><i class="pi pi-exclamation-triangle"></i> There is no data to display. Please adjust your filter.</div>
                  </div>
            </div>

            <div *ngIf="isArrayWithData(tableData)" class="flex-1">
                <div class="table">
                    <div class="table-header">
                        <div>Creditor ID</div>                    
                        <div>Error Code</div>
                        <div>Count</div>
                        <div>% of Total</div>
                    </div>

                    <div
                        class="table-row"
                        *ngFor="let row of tableData"
                    >
                        <div class="creditor-cell">
                            <span
                                class="color-dot"
                                [style.background]="row.color"
                            ></span>

                            {{ row.creditorId }}
                        </div>

                        <div>{{ row.errorCode }}</div>

                        <div>{{ row.count | number }}</div>

                        <div>{{ row.percent }}%</div>
                    </div>

                    <div class="table-footer">
                        <div>Total</div>   
                        <div></div>                 
                        <div>{{ totalCount | number }}</div>
                        <div>100.0%</div>
                    </div>
                </div>
            </div>
          </div>




        </div>

</div>
